// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "flowbite/dist/flowbite.turbo.js";
import "./controllers"
import "./renderjson_init"

import "trix"
import "@rails/actiontext"
